import { render, staticRenderFns } from "./OrganizationMerge.vue?vue&type=template&id=47c7b2d1&scoped=true&"
import script from "./OrganizationMerge.vue?vue&type=script&lang=js&"
export * from "./OrganizationMerge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c7b2d1",
  null
  
)

export default component.exports